import { HttpApiSchema } from "@effect/platform";
import { Effect, Predicate, Schema } from "effect";
export const ErrorBaseSchema = Schema.Struct({
    type: Schema.String,
    title: Schema.String,
    detail: Schema.String
});
export class InternalServerError extends Schema.TaggedError()("@open-revenue/schema/models/errors/InternalServerError", {
    ...ErrorBaseSchema.fields,
    cause: Schema.Defect,
    type: Schema.optionalWith(ErrorBaseSchema.fields.type, {
        default: ()=>"https://superwall.com/open-revenue/errors/internal-server-error"
    })
}, HttpApiSchema.annotations({
    status: 500,
    title: "InternalServerError",
    description: "An unexpected error occurred"
})) {
    static is(u) {
        return Predicate.isTagged(u, "@open-revenue/schema/models/errors/InternalServerError");
    }
}
export class NotFoundError extends Schema.TaggedError()("@open-revenue/schema/models/errors/NotFoundError", {
    ...ErrorBaseSchema.fields,
    type: Schema.optionalWith(ErrorBaseSchema.fields.type, {
        default: ()=>"https://superwall.com/open-revenue/errors/not-found-error"
    })
}, HttpApiSchema.annotations({
    status: 404,
    title: "NotFoundError",
    description: "The requested resource was not found"
})) {
    static is(u) {
        return Predicate.isTagged(u, "@open-revenue/schema/models/errors/NotFoundError");
    }
}
export class BadRequestError extends Schema.TaggedError()("@open-revenue/schema/models/errors/BadRequestError", {
    ...ErrorBaseSchema.fields,
    type: Schema.optionalWith(ErrorBaseSchema.fields.type, {
        default: ()=>"https://superwall.com/open-revenue/errors/bad-request-error"
    })
}, HttpApiSchema.annotations({
    status: 400,
    title: "BadRequestError",
    description: "The request was malformed"
})) {
    static is(u) {
        return Predicate.isTagged(u, "@open-revenue/schema/models/errors/BadRequestError");
    }
}
export class UnauthorizedError extends Schema.TaggedError()("@open-revenue/schema/models/errors/UnauthorizedError", {
    ...ErrorBaseSchema.fields,
    type: Schema.optionalWith(ErrorBaseSchema.fields.type, {
        default: ()=>"https://superwall.com/open-revenue/errors/unauthorized-error"
    })
}, HttpApiSchema.annotations({
    status: 401,
    title: "UnauthorizedError",
    description: "Authentication is required to access this resource"
})) {
    static is(u) {
        return Predicate.isTagged(u, "@open-revenue/schema/models/errors/UnauthorizedError");
    }
}
//
// Products
//
//
// Configuration
//
export class ConfigUpdateError extends Schema.TaggedError()("@open-revenue/schema/models/errors/ConfigUpdateError", {
    ...ErrorBaseSchema.fields,
    cause: Schema.Defect,
    type: Schema.optionalWith(ErrorBaseSchema.fields.type, {
        default: ()=>"https://superwall.com/open-revenue/errors/config-error"
    })
}, HttpApiSchema.annotations({
    status: 400,
    title: "ConfigError",
    description: "An error occurred while updating the configuration"
})) {
    static is(u) {
        return Predicate.isTagged(u, "@open-revenue/schema/models/errors/ConfigUpdateError");
    }
    static refail(message) {
        return (effect)=>Effect.catchIf(effect, (e)=>!ConfigUpdateError.is(e), ()=>new ConfigUpdateError({
                    title: `Unable to update configuration`,
                    detail: message,
                    cause: new Error(message)
                }));
    }
}
export class StoreConfigurationNotValidError extends Schema.TaggedError()("@open-revenue/schema/models/errors/StoreConfigurationNotValidError", {
    ...ErrorBaseSchema.fields,
    type: Schema.optionalWith(ErrorBaseSchema.fields.type, {
        default: ()=>"https://superwall.com/open-revenue/errors/store-configuration-not-valid-error"
    })
}, HttpApiSchema.annotations({
    status: 400,
    title: "StoreConfigurationNotValidError",
    description: "The store configuration is not valid, unable to fetch required keys."
})) {
    static is(u) {
        return Predicate.isTagged(u, "@open-revenue/schema/models/errors/StoreConfigurationNotValidError");
    }
    static refail(message) {
        return (effect)=>Effect.catchIf(effect, (e)=>!StoreConfigurationNotValidError.is(e), ()=>new StoreConfigurationNotValidError({
                    title: "Configuration not valid",
                    detail: message
                }));
    }
}
